import { useEffect, useState } from 'react';
import clsx from 'clsx';

import { TextField } from '@atom/mui';
import { TaskField } from '@atom/types/task';
import {
  CustomFieldView,
  getTaskFieldWidth,
} from '@atom/utilities/taskUtilities';

import classes from './taskFields.module.css';

interface Props {
  field: TaskField;
  taskId?: string;
  onChange: (fieldId: string, value: any) => void;
  onBlur: (fieldId: string, value: any) => void;
  isDisabled: boolean;
  previewView?: boolean;
  error?: boolean;
  helperText?: string;
  onClick?: () => void;
  customFieldView: CustomFieldView;
}

const TaskTextField = ({
  field,
  taskId,
  onChange,
  onBlur,
  isDisabled,
  error = false,
  helperText,
  onClick,
  customFieldView,
}: Props) => {
  const [value, setValue] = useState<string>(field?.value || '');

  useEffect(() => {
    setValue(field?.value || '');
  }, [taskId, field?.id]);

  const handleChange = event => {
    setValue(event.target.value);
    onChange(field.id, event.target.value);
  };

  const handleOnBlur = event => {
    if (field?.value !== event.target.value) {
      setValue(event.target.value);
      onBlur(field.id, event.target.value);
    }
  };

  const containerWidth = {
    maxWidth: getTaskFieldWidth(customFieldView),
  };

  const title =
    field.required && customFieldView !== CustomFieldView.FILTER
      ? `* ${field.title}`
      : field.title;

  return (
    <div
      onClick={onClick}
      style={containerWidth}
      className={classes.fieldContainer}
    >
      <div
        className={clsx(classes.fieldTitle, error && classes.fieldTitleError)}
      >
        {title}
      </div>
      <TextField
        id={field.id}
        value={value}
        disabled={isDisabled}
        onChange={handleChange}
        onBlur={handleOnBlur}
        multiline
        error={error}
        helperText={helperText}
        onClick={onClick}
        data-cy={`taskField-${field.title}-TextInput`}
      />
    </div>
  );
};

export default TaskTextField;
